module.exports = __webpack_public_path__ + "img/facebook.4c5d1ef2.svg";